// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../services/route-guards/auth.guard';
import { DealerGuard } from './deals/dealer.guard';
import { PddjDealsComponent } from './pddj-deals/pddj-deals.component';
import { PddjDoneComponent } from './done/pddj-done.component';
import { PddjLoginComponent } from './login/pddj-login.component';
import { PddjResolverService } from './pddj-resolver.service';
import { PddjStatusComponent } from './status/pddj-status.component';
import { PddjUploadComponent } from './upload/pddj-upload.component';
import { DealerHelpComponent } from '../dealer/dealer-help/dealer-help.component';
import { HelpPageResolver } from '@services/resolvers/help-page-resolver';
import { UserResolver } from '@services/resolvers/user.resolver';
import { DealsResolver } from '@services/resolvers/deals.resolver';
import { DealResolver } from '@services/resolvers/deal.resolver';
import { DealershipResolver } from '@services/resolvers/dealership.resolver';
import { TemplateListResolver } from '@services/resolvers/template-list.resolver';

const routes: Routes = [
    {
        path: 'login',
        component: PddjLoginComponent,
    },
    {
        path: 'deals',
        canActivate: [AuthGuard, DealerGuard],
        resolve: {
            deals: DealsResolver,
        },
        component: PddjDealsComponent,
    },
    {
        path: 'done',
        canActivate: [AuthGuard, DealerGuard],
        resolve: { dealer: DealershipResolver },
        component: PddjDoneComponent,
    },
    {
        path: 'help',
        canActivate: [AuthGuard, DealerGuard],
        component: DealerHelpComponent,
        resolve: {
            help: HelpPageResolver,
            user: UserResolver,
        },
    },
    {
        path: 'status',
        canActivate: [AuthGuard, DealerGuard],
        resolve: { dealer: DealershipResolver },
        component: PddjStatusComponent,
    },
    {
        path: ':dealId/upload',
        canActivate: [AuthGuard, DealerGuard],
        resolve: {
            pddj: PddjResolverService,
            dealer: DealershipResolver,
            deal: DealResolver,
            forms: TemplateListResolver,
        },
        component: PddjUploadComponent,
    },
    {
        path: '',
        redirectTo: 'deals',
        pathMatch: 'full',
    },
    {
        path: '**',
        redirectTo: 'deals',
        pathMatch: 'full',
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PddjRoutingModule {}
